import { ICharacterState } from '../../interfaces/ICharacterState';
import { Character } from '../Character';
import { NpcStateBase } from './NpcStateBase';
import { CharacterAnimation } from '../../enums/CharacterAnimation';
import { Idle } from './Idle';

export class IdleReposition extends NpcStateBase implements ICharacterState {
    constructor(character: Character) {
        super(character);
        this.character.simulation.setArcadeVelocityTarget(0);
        this.playAnimation(CharacterAnimation.IdleReposition, 0.1, true, false);
    }

    public update(timeStep: number): void {
        super.update(timeStep);
        if (this.animationEnded(timeStep)) {
            this.character.setState(new Idle(this.character));
        }
    }

    public onInputChange(): void {
        super.onInputChange();
    }
}
